import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginForm, RegisterForm, ForgotPasswordForm, ResetPasswordForm } from '../component/auth';
import { Layout } from '../component/layout';
import { Upload } from '../component/upload';
import { Results } from '../component/results';
import { PastPaperList } from '../component/past-paper';
import AuthRoute from './AuthRoute';
import Payment from '../component/payment/Payment';
import PlansManagement from '../component/payment/PlansManagement';
import TransactionsHistory from '../component/payment/TransactionsHistory';


const AppRoutes = () => {
  return (
    <Routes>
      <Route 
        path="/login" 
        element={
          <AuthRoute type="public">
            <LoginForm />
          </AuthRoute>
        } 
      />
      <Route 
        path="/register" 
        element={
          <AuthRoute type="public">
            <RegisterForm />
          </AuthRoute>
        } 
      />
      <Route 
        path="/forgot-password" 
        element={
          <AuthRoute type="public">
            <ForgotPasswordForm />
          </AuthRoute>
        } 
      />
      <Route 
        path="/reset-password" 
        element={
          <AuthRoute type="public">
            <ResetPasswordForm />
          </AuthRoute>
        } 
      />
      
      <Route 
        path="/" 
        element={
          <AuthRoute type="protected">
            <Layout>
              <Upload />
            </Layout>
          </AuthRoute>
        } 
      />
      <Route 
        path="/upload" 
        element={
          <AuthRoute type="protected">
            <Layout>
              <Upload />
            </Layout>
          </AuthRoute>
        } 
      />
      <Route 
        path="/results" 
        element={
          <AuthRoute type="protected">
            <Layout>
              <Results />
            </Layout>
          </AuthRoute>
        } 
      />
      <Route 
        path="/past-paper" 
        element={
          <AuthRoute type="protected">
            <Layout>
              <PastPaperList />
            </Layout>
          </AuthRoute>
        } 
      />
      <Route 
        path="/payment" 
        element={
          <AuthRoute type="protected">
            <Layout>
              <PlansManagement />
            </Layout>
          </AuthRoute>
        } 
      />
      <Route 
        path="/plans-management" 
        element={
          <AuthRoute type="protected">
            <Layout>
              <PlansManagement />
            </Layout>
          </AuthRoute>
        } 
      />
      <Route 
        path="/payment-history" 
        element={
          <AuthRoute type="protected">
            <Layout>
              <Payment />
            </Layout>
          </AuthRoute>
        } 
      />
      <Route 
        path="/history" 
        element={
          <AuthRoute type="protected">
            <Layout>
              <TransactionsHistory />
            </Layout>
          </AuthRoute>
        } 
      />
            <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes; 